import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Plus } from "lucide-react";
import api, { formatErr } from "../../lib/api";

export default function DevContent() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const [newKey, setNewKey] = useState("");
  const refresh = () => api.get("/developer/content").then(r=>setItems(r.data));
  useEffect(()=>{ refresh(); }, []);
  const save = async () => {
    try { await api.put(`/developer/content/${active.key}`, { title: active.title, body: active.body }); toast.success("Saved"); refresh(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const create = async () => {
    if (!newKey) return;
    await api.put(`/developer/content/${newKey}`, { title: newKey, body: "" });
    setNewKey(""); refresh();
  };
  return (
    <div className="space-y-6">
      <div><div className="overline mb-2">CMS</div><h1 className="font-display text-4xl text-white">Site Content</h1>
      <p className="text-sm text-white/50 mt-2">Edit copy displayed across the storefront. Changes go live instantly.</p></div>

      <div className="grid md:grid-cols-[260px_1fr] gap-6">
        <div className="space-y-2">
          {items.map(c => (
            <button key={c.key} data-testid={`cnt-${c.key}`} onClick={()=>setActive({...c})} className={`w-full text-left card-luxe p-4 ${active?.key===c.key?"border-copper":""}`}>
              <div className="font-mono text-[11px] text-white/40">{c.key}</div>
              <div className="text-white text-sm mt-1">{c.title}</div>
            </button>
          ))}
          <div className="card-luxe p-3 flex gap-2">
            <input className="input-box flex-1 text-xs" placeholder="new_key" value={newKey} onChange={(e)=>setNewKey(e.target.value)}/>
            <button onClick={create} className="btn-primary px-3"><Plus size={13}/></button>
          </div>
        </div>
        {active && (
          <div className="card-luxe p-6 space-y-4">
            <div className="font-mono text-xs text-white/40">{active.key}</div>
            <div><div className="overline mb-2">Title</div><input data-testid="cnt-title" className="input-box" value={active.title||""} onChange={(e)=>setActive({...active, title:e.target.value})}/></div>
            <div><div className="overline mb-2">Body</div><textarea data-testid="cnt-body" rows={12} className="input-box resize-none" value={active.body||""} onChange={(e)=>setActive({...active, body:e.target.value})}/></div>
            <button data-testid="cnt-save" onClick={save} className="btn-primary"><Save size={13}/> Save</button>
          </div>
        )}
      </div>
    </div>
  );
}
